<template>

<div class="head">

	<div class="head-title">Recommendation</div>

</div>

</template>

<script>

export default {

	props: ['name']

}

</script>

<style scoped>

.head {
	padding-bottom: 90px;
}

.is-mobile .head {
	padding-bottom: 48px;
}

.head-title {
	color: #343434;
	font-size: 36px;
	line-height: 36px;
	font-weight: 100;
	letter-spacing: 3px;
	text-transform: uppercase;
	flex-shrink: 0;
}

.is-mobile .head-title {
	font-size: 18px;
	line-height: 18px;
}

.head-title:after {
	content: ' ';
	position: absolute;
	bottom: -26px;
	left: 0px;
	height: 4px;
	background-color: var(--primary-color);
	width: 150px;
}

.is-mobile .head-title:after {
	bottom: -20px;
	width: 76px;
}

</style>